module.exports = __webpack_public_path__ + "img/javascript.376949e2.svg";